import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "font-weight-bold form-label-required mb-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DatePicker = _resolveComponent("DatePicker");
    const _component_Field = _resolveComponent("Field");
    const _component_ErrorMessage = _resolveComponent("ErrorMessage");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.tr('common.END_DATE')), 1),
        _createVNode(_component_Field, {
            name: _ctx.tr('common.END_DATE'),
            "model-value": _ctx.modelValue,
            rules: _ctx.Validator.CUSTOM('end_time_before_now'),
            "validate-on-input": "",
            "validate-on-model-update": ""
        }, {
            default: _withCtx(({ field, meta }) => [
                _createVNode(_component_DatePicker, {
                    "model-value": field.value,
                    "allow-future-dates": true,
                    "disabled-dates": { 'to': new Date() },
                    "with-time-selection": true,
                    state: _ctx.getStateForComponentValidation(meta),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', $event)))
                }, null, 8, ["model-value", "disabled-dates", "state"])
            ]),
            _: 1
        }, 8, ["name", "model-value", "rules"]),
        _createVNode(_component_ErrorMessage, {
            name: _ctx.tr('common.END_DATE'),
            as: "div",
            class: "text-danger mt-1"
        }, null, 8, ["name"])
    ]));
}
